import { cn } from "@/lib/utils";

interface OnboardingChipProps {
  icon: React.ReactNode;
  label: string;
  selected: boolean;
  dismissing?: boolean;
  onClick: () => void;
}

export function OnboardingChip({
  icon,
  label,
  selected,
  dismissing,
  onClick,
}: OnboardingChipProps) {
  return (
    <button
      onClick={onClick}
      className={cn(
        "flex w-full cursor-pointer items-start gap-3 rounded-xl border px-4 py-3.5 text-left text-sm font-medium transition-all duration-300",
        selected
          ? "border-foreground bg-foreground/5 text-foreground"
          : "border-border bg-background text-foreground/80 hover:border-foreground/30",
        dismissing && !selected && "opacity-0 scale-95",
      )}
    >
      <span className="mt-0.5 shrink-0 text-base">{icon}</span>
      <span>{label}</span>
    </button>
  );
}
